/** 排在最前：尽早抹掉地址栏上的一键登录票据，原因见该模块注释 */
import '@/utils/ticketParam';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from '@/router';
import { registerDirectives } from '@/directives';
import { setupMonitor } from '@/monitor';
import { setupAppUpdateNotice } from '@/utils/appUpdate';
import { setupAuthSync } from '@/utils/authSync';
import { hasLoginTicket, loginByTicket } from '@/utils/ticketLogin';
import ElementPlus, { ElDialog } from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';

/** 全局：弹框点击遮罩不关闭 */
ElDialog.setPropsDefaults({ closeOnClickModal: false });
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';

dayjs.locale('zh-cn');

import 'virtual:uno.css';
import 'element-plus/dist/index.css';
import '@/styles/index.scss';
import '@/utils/request';
import { setupDisplayScale } from '@/utils/displayScale';
import { setupEnterSearch } from '@/utils/enterSearch';

/** 小屏笔记本整体缩放适配（窗口宽度 <= 1440px 时缩到 90%） */
setupDisplayScale();

/** 全局：standard-filter-form 内任意输入框按回车自动触发「查询」 */
setupEnterSearch();

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(ElementPlus, { locale: zhCn });

/** 自定义指令注册 */
registerDirectives(app);

/** 前端监控：异常与性能采集，由 VITE_MONITOR_ENABLED 控制，生产环境默认开启 */
setupMonitor(app, router);

/** 发版更新提示：老页面请求到已被覆盖的旧 chunk 时，提示用户刷新 */
setupAppUpdateNotice(router);

/** 多标签页登录态同步：其他标签页退出或换账号后，本页整页重载，避免沿用上一个账号的数据 */
setupAuthSync(router);

/**
 * 技术支持一键登录：URL 带票据时先换登录态，成功后整页重载，不再挂载当前实例。
 *
 * 放在挂载前而不是路由守卫里：守卫中已登录会直接放行去首页、未登录会跳登录页，
 * 两条路都绕不开；入口处理才能做到「不管当前是否已登录都执行登录」。
 */
if (hasLoginTicket()) {
  loginByTicket().then((reloading) => {
    if (!reloading) app.mount('#app');
  });
} else {
  app.mount('#app');
}
